import { useIsAuthenticated } from "@azure/msal-react"
import { useEffect } from "react"

import { fetchXRM } from "src/helpers/fetchQueriesXRM"
import { getSalesorderById } from "src/queriesXRM/salesorder"
import { useLocale } from "src/states/locale"
import { getSalesorder, mergeSalesorder } from "src/states/salesorder"

/**
 * Lädt beim Seitenaufruf alle relevanten Daten vom Server und schreibt sie in den Local Storage unter den jeweiligen asp-Keys.
 */
export default function LocalStorageSync() {
  const locale = useLocale()
  const isAuthenticated = useIsAuthenticated()
  useEffect(() => {
    if (!isAuthenticated) return
    ;(async () => {
      try {
        await fetchXRM(locale)
        // Get the current salesorderId from state (if any)
        const currentState = await getSalesorder()
        const salesorderId = currentState?.salesorderId
        if (salesorderId) {
          // Fetch latest salesorder from server
          const serverSalesorder = await getSalesorderById(salesorderId)
          if (serverSalesorder) {
            // Update local state with server data
            mergeSalesorder(serverSalesorder)
          }
        }
        // Now get the updated state and write to localStorage
        const updatedState = await getSalesorder()
        if (updatedState)
          localStorage.setItem("asp-salesorder", JSON.stringify(updatedState))
        localStorage.setItem("asp-sync-timestamp", new Date().toISOString())
      } catch (err) {
        console.debug("LocalStorageSync server fetch failed", err)
      }
    })()
  }, [locale, isAuthenticated])
  return null
}
